import React from 'react'
import { Text, Flex } from 'pcln-design-system'
import { useResetHandlers } from '../Filters/Hooks/useResetHandlers'
import { useDebouncedListingsFilterCall } from '@mfs/client/listings-client/components/Filters/useDebouncedListingsFilterCall/useDebouncedListingsFilterCall'
import { logFilterResetOverfilter } from '../../../common/log-ga-event/logGaEvent-overfilter-filter-reset'
import { StyledButton } from './OverfilteredBanner.styles'
import { useSelector } from 'react-redux'

const OverfilteredBannerContent = () => {
  const { resetClickAirlines, resetClickTime, resetClickAirports, resetClickStops, resetClicksAttributes } =
    useResetHandlers()
  const { debouncedListingsFilterCall } = useDebouncedListingsFilterCall()
  const pclnBootstrapData = useSelector((state) => state.pclnBootstrapData)

  const resetFilters = () => {
    const shouldFireChange = false
    resetClickAirlines({ shouldFireChange })
    resetClickTime('takeoff', shouldFireChange)
    resetClickTime('landing', shouldFireChange)
    resetClickAirports({ shouldFireChange })
    resetClickStops({ shouldFireChange })
    resetClicksAttributes({ shouldFireChange })
    logFilterResetOverfilter()
    debouncedListingsFilterCall(pclnBootstrapData, 'filter')
  }

  return (
    <>
      <Flex justifyContent={'space-between'}>
        <Flex flexWrap={'wrap'} mr={2}>
          <Text color={'text.dark'} fontSize={[0, 0, 1, 1, 1]}>
            <Text.span bold>Results not found, </Text.span>below are your previous results. Try adjusting one
            of your active search filters, or reset all filters
          </Text>
        </Flex>
        <Flex alignItems={'center'}>
          <StyledButton onClick={resetFilters}>
            <Text fontSize={0}>Reset All Filters</Text>
          </StyledButton>
        </Flex>
      </Flex>
    </>
  )
}
export { OverfilteredBannerContent }
